import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserLog')
export class UserLog {

  @JsonProperty('log_id', Number)
  logId: number = 0;

  @JsonProperty('request_url', String)
  requestUrl: string = '';

  @JsonProperty('request_body', String)
  requestBody: string = '';

  @JsonProperty('response_http_code', Number)
  responseHttpCode: number = 0;

  @JsonProperty('response_error_code', Number)
  responseErrorCode: number = 0;

  @JsonProperty('application_version', String)
  applicationVersion: string = '';

  @JsonProperty('message', String)
  message: string = '';

  @JsonProperty('created_at_timestamp', Number)
  createdAtTimestamp: number = 0;
}
